.button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: var(--space-2);
  min-width: var(--target-min);
  min-height: var(--control-h);
  padding: 0 var(--space-4);
  border: 1.5px solid var(--color-control-border);
  border-radius: var(--radius-button);
  background: var(--color-panel);
  color: var(--color-ink);
  font: inherit;
  font-weight: 600;
  line-height: 1.2;
  text-decoration: none;
  cursor: pointer;
  box-shadow: 0 var(--press-offset) 0 var(--control-edge);
  transition:
    background-color var(--motion-fast),
    transform var(--motion-fast),
    box-shadow var(--motion-fast);
}

/* Pressed depth (tabletop 3.1): the solid edge collapses as the key travels down. Forced colours drop shadows; borders remain. */
.button:active:not(:disabled) {
  transform: translateY(var(--press-offset));
  box-shadow: 0 0 0 var(--control-edge);
}

.button:hover:not(:disabled) {
  background: var(--color-given-bg);
}

.button:disabled {
  color: var(--color-muted);
  cursor: not-allowed;
  box-shadow: none;
}

.primary,
.danger,
.button[aria-pressed='true'] {
  background: var(--control-accent, var(--color-accent));
  border-color: var(--control-accent, var(--color-accent));
  color: var(--color-accent-ink);
}

.primary:hover:not(:disabled),
.button[aria-pressed='true']:hover:not(:disabled) {
  background: var(--control-accent-hover, var(--color-accent-hover));
}

.danger,
.danger:hover:not(:disabled) {
  background: var(--color-danger);
  border-color: var(--color-danger);
}

.primary:disabled {
  box-shadow: none;
  background: var(--color-given-bg);
  border-color: var(--color-control-border);
  color: var(--color-muted);
}

.quiet {
  border-color: transparent;
  background: transparent;
  color: var(--color-ink);
  box-shadow: none;
}

.quiet:active:not(:disabled) {
  transform: none;
}
